<template>
    <div class="settings__version">
        <div class="settings__version-item">
            <span class="bold">{{ getTranslatedText('Merchant App Version') }} {{ $store.state.versionApp }}</span>
        </div>
        <div class="settings__version-item">
            <span class="bold">{{ getTranslatedText('Terminal ID') }}: </span> <span>{{ renderTerminalID() }}</span>
        </div>
        <div class="settings__version-item">
            <span class="bold">{{ getTranslatedText('Environment') }} {{ environment }}</span>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language/language-mixins'
import { getUserInfo } from '@/services/axios'
import { isStrEmpty } from '@/utils/utils'

export default {
    mixins: [languageMixins],
    data() {
        return {
            environment:process.env.VUE_APP_ENVIRONMENT
        }
    },
    methods: {
        renderTerminalID() {
            let terminalId = !isStrEmpty(getUserInfo()) ? getUserInfo() : ''
            if (!isStrEmpty(getUserInfo())) {
                let info = JSON.parse(getUserInfo())
                terminalId = info.teller_id
            }
            return terminalId
        },
    },
}
</script>
